import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { UserAvatar } from "@/components/common/UserAvatar";

/** Avatar that shows the person's uploaded photo (fetched as an authenticated blob) or initials. */
export function PhotoAvatar({ personId, name, size = 56, hasPhoto, refreshKey = 0 }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let revoke;
    if (personId && hasPhoto) {
      api.get(`/persons/${personId}/photo`, { responseType: "blob" })
        .then((r) => { revoke = URL.createObjectURL(r.data); setUrl(revoke); })
        .catch(() => setUrl(null));
    } else setUrl(null);
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [personId, hasPhoto, refreshKey]);

  if (url) {
    return <img src={url} alt={name} data-testid="person-photo" className="rounded-full object-cover shrink-0"
      style={{ width: size, height: size }} />;
  }
  return <UserAvatar name={name} size={size} />;
}
